// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductDetailViewNewKiosk/style.kiosk.css
// module id = 2041
// module chunks = 0